import { HealthProgramStatisticsResponse, ScreeningInsightsResponse } from '@estercare/ester-shared'

export const hasInsufficientReportData = (
  insights?: ScreeningInsightsResponse,
  statistics?: HealthProgramStatisticsResponse
): boolean => {
  const insightBlocks = [
    insights?.improvedWorkAbility,
    insights?.lifestyleChange,
    insights?.decreasedSymptoms3m,
    insights?.severityByCondition,
    insights?.severeScreenings,
    insights?.careNeedLevel3,
    insights?.ageDistribution,
    insights?.productivityBySeverity,
  ]
  const programBlocks = [
    statistics?.participants,
    statistics?.followedSelfCareAdvicePct,
    statistics?.soughtCareWhenNeededPct,
    statistics?.productivityChange,
    statistics?.healthPlanRelevance,
  ]

  return (
    insightBlocks.some((block) => block === undefined) ||
    programBlocks.some((block) => block === null || block === undefined) ||
    (statistics?.symptomChanges.length ?? 0) === 0
  )
}
